<!-- Caricom Invoice Format -->
<div class="caricom-invoice-container">
  <div class="invoice-page" *ngFor="let invoice of invoices; let i = index">

    <!-- Header Section -->
    <div class="invoice-header">
      <div class="company-logo-section">
        <div class="logo-circle">
          <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo"
            style="width: 100%; height: 100%; object-fit: contain;">
          <span *ngIf="!logoUrl" class="logo-text">SMJ</span>
        </div>
      </div>

      <div class="company-details">
        <h3>{{ settings?.company }}</h3>
        <p>{{ settings?.city }}, {{ settings?.state }}, JAPAN</p>
        <p><strong>TEL:</strong> {{ settings?.telephone }} <strong>FAX:</strong> {{ settings?.fax }}</p>
        <p><strong>E-MAIL:</strong> {{ settings?.email_1 }}</p>
      </div>
    </div>

    <!-- Invoice Title -->
    <div class="invoice-title">
      <h1>CARICOM INVOICE</h1>
    </div>

    <!-- Market Information -->
    <div class="market-info">
      <span class="market-label">FOR CARIBBEAN MARKET</span>
    </div>

    <!-- Main Information Table -->
    <div class="main-info-table">
      <table class="info-table">
        <tr>
          <td class="label-cell">SELLER (NAME, FULL ADDRESS, COUNTRY)</td>
          <td class="label-cell">INVOICE NO.</td>
          <td class="label-cell">CUSTOMERS ORDER NO.</td>
        </tr>
        <tr>
          <td class="data-cell">
            <strong>IMPERIAL SOLUTIONS LTD.</strong><br>
            2F-14 AOBADAI<br>
            KITAKU, KOBE 651-1231, JAPAN
          </td>
          <td class="data-cell">{{ invoice.invoice_number }}</td>
          <td class="data-cell">{{ invoice.order?.order_number || '-' }}</td>
        </tr>
        <tr>
          <td class="label-cell" colspan="3">OTHER REFERENCES</td>
        </tr>
        <tr>
          <td class="data-cell" colspan="3">-</td>
        </tr>
      </table>
    </div>

    <!-- Buyer and Consignee Information -->
    <div class="buyer-consignee-table">
      <table class="info-table">
        <tr>
          <td class="label-cell">BUYER (IF OTHER THAN CONSIGNEE)</td>
          <td class="label-cell" rowspan="2">PRESENTING BANK</td>
        </tr>
        <tr>
          <td class="data-cell">
            <strong>{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</strong>
          </td>
        </tr>
        <tr>
          <td class="label-cell">CONSIGNEE (NAME, FULL ADDRESS, COUNTRY)</td>
          <td class="data-cell">MIZUHO BANK LTD.</td>
        </tr>
        <tr>
          <td class="data-cell">
            <strong>{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</strong><br>
            {{ invoice.order?.buyer_street_address }}<br>
            {{ invoice.order?.buyer_city }}, {{ invoice.order?.buyer_country }}
          </td>
          <td class="label-cell">COUNTRY OF ORIGIN OF GOODS</td>
        </tr>
        <tr>
          <td class="label-cell">PORT OF LOADING</td>
          <td class="data-cell">JAPAN</td>
        </tr>
        <tr>
          <td class="data-cell">{{ invoice.ship? invoice.ship.sailing_port : invoice.order?.from_port }}</td>
          <td class="label-cell">TERMS AND CONDITIONS OF DELIVERY AND PAYMENT</td>
        </tr>
        <tr>
          <td class="label-cell">COUNTRY OF FINAL DESTINATION</td>
          <td class="data-cell">{{invoice.order?.ship_type || '-' }}</td>
        </tr>
        <tr>
          <td class="data-cell">{{ invoice.ship? invoice.ship.destination_country : invoice.order?.to_country}}</td>
          <td class="label-cell">CURRENCY OF SALE</td>
        </tr>
        <tr>
          <td class="empty-cell"></td>
          <td class="data-cell" *ngIf="invoice.item">
            {{ invoice.item?.currency || 'USD' }}
          </td>
          <!-- <td class="data-cell" *ngIf="viewMode === 'merged' && invoice.vehicles">
            {{ invoice.vehicles[0]?.item?.currency || 'USD' }}
          </td> -->
        </tr>
      </table>
    </div>

    <!-- Vehicle Details Table -->
    <div class="vehicle-details-table">
      <table class="vehicle-table">
        <thead>
          <tr>
            <th>STOCK NO.</th>
            <th>PARTICULARS</th>
            <th>CHASSIS #</th>
            <th>QTY</th>
            <th>G WEIGHT</th>
            <th>CUBE M3</th>
            <th>AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          <!-- Individual Vehicle Mode -->
          <ng-container *ngIf="viewMode !== 'merged' || !invoice.vehicles">
            <tr>
              <td>{{ getStockNumber(invoice) }}</td>
              <td>{{ invoice.vehicle?.company_name }} {{ invoice.vehicle?.name }}</td>
              <td>{{ getChassisNumber(invoice) }}</td>
              <td>1</td>
              <td>{{ invoice.vehicle?.g_weight }}</td>
              <td>-</td>
              <td>{{ formatCurrency(invoice.invoice_amount, invoice.item?.currency) }}</td>
            </tr>
          </ng-container>

          <!-- Merged Vehicles Mode -->
          <ng-container *ngIf="viewMode === 'merged' && invoice.vehicles">
            <tr *ngFor="let vehicle of invoice.vehicles; let idx = index">
              <td>{{ vehicle.car_no || '-' }}</td>
              <td>{{ vehicle.company_name }} {{ vehicle.name }}</td>
              <td>{{ vehicle.vin_no || '-' }}</td>
              <td>1</td>
              <td>{{ vehicle.g_weight }}</td>
              <td>-</td>
              <td>{{ formatCurrency(vehicle.invoice_amount, vehicle.item?.currency) }}</td>
            </tr>
          </ng-container>

          <tr class="total-row">
            <td colspan="6"><strong>TOTAL</strong></td>
            <td><strong>{{ formatCurrency(invoice.invoice_amount, invoice.item?.currency) }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Certification Text -->
    <div class="certification-text">
      <p>IT IS HEREBY CERTIFIED THAT THIS INVOICE SHOWS THE ACTUAL PRICE OF THE GOOD DESCRIBED, THAT NO OTHER HAS
      BEEN OR WILL BE ISSUED AND THAT ALL PARTICULARS ARE TRUE AND CORRECT</p>
    </div>

    <!-- Signature and Total Section -->
    <div class="signature-total-section">
      <div class="signature-area">
        <div class="stamp-area">
          <div class="imperial-stamp">
            IMPERIAL<br>
            SOLUTIONS
          </div>
        </div>
        <div class="signature-line">
          <p>INTERNATIONAL EXPORT MANAGER</p>
        </div>
      </div>

      <div class="total-amount-box">
        <div class="total-label">TOTAL INVOICE AMOUNT</div>
        <div class="total-value">{{ formatCurrency(invoice.invoice_amount, invoice.item?.currency) }}</div>
      </div>
    </div>

    <!-- Terms of Trade -->
    <div class="terms-section">
      <h4>TERMS OF TRADE</h4>
      <div class="terms-content">
        <p><strong>1. SHIPMENT DEPOSIT:</strong> FOR THE UNITS BOUGHT FROM AUCTION, STOCK MUST BE PAID WITHIN 15 DAYS FROM PURCHASE
        DATE. IF THE SHIPMENT DEPOSIT IS NOT PAID WITHIN 15 DAYS, COMPANY MONEY WILL BE CHARGED DAILY PENALTY UNTIL
        IMPERIAL SOLUTIONS LIMITED ACCOUNT SHALL BE ASSIGNED TO THE ABOVE UNIT FIRST WITHOUT EXCEPTION EVEN IF
        THOSE PAYMENTS WERE SENT TO COMPLETE BALANCE ON ALREADY ARRIVED UNITS AT THE DESTINATION PORT.</p>

        <p><strong>2. IMPERIAL SOLUTIONS LIMITED:</strong> MAY NOT SURRENDER OR RELEASE BILL FOR ANY UNIT BASED ON TT SCAN. ISL MAY ONLY
        SURRENDER OR RELEASE BASED ON THE REMITTANCE CONFIRMATION AT OUR BANK.</p>

        <p><strong>3. CUSTOMER NEEDS TO PAY THE BALANCE BEFORE OR WITHIN 14 DAYS OF ARRIVAL AT PORT OR A DAILY PENALTY OF 1,000
        JPY PER DAY WILL BE CHARGED UNTIL THE BALANCE IS PAID. CHARGES WITHIN 30 DAYS OF
        ARRIVAL DATE OR NO COMMUNICATION GIVES I.S.L THE RIGHTS TO RE-SALE YOUR VEHICLE TO ANOTHER BUYER WITH ANY
        OCCUPATION LOSSES TO BE RECOVERED FROM YOUR DEPOSIT.</strong></p>

        <p><strong>4. ALL UNITS SUBJECTED TO SHIPPING ON 30% OR 50% DEPOSIT SHALL ONLY BE SHIPPED THROUGH C&F (CARIBBEAN AUTO
        TERMINAL) ONLY. YOU CAN REQUEST SHIPMENT ON THE CONSIGNEE OF YOUR CHOICE ONLY AFTER FULL PAYMENT IS MADE
        BEFORE SHIPMENT.</strong></p>
      </div>
    </div>

    <!-- Page Break (except for last invoice) -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
